import { InputFieldType } from '@e2m-customer-portal/shared';

export interface ProductInput {
  product: InputFieldType;
  input: HTMLInputElement | null;
}

export function moveControlEnergyFocusUp(
  sourceRow: number,
  sourceColumn: number,
  sourceProductIndex: number,
  lastRow: number,
  lastColumn: number,
  lastProductIndex: number,
  deviceMap: ProductInput[][][],
) {
  let row = sourceRow;
  let column = sourceColumn;
  let productIndex = sourceProductIndex;

  do {
    if (row === 0 && productIndex === 0) {
      column = column === 0 ? lastColumn : column - 1;
    }
    if (productIndex === 0) {
      row = row === 0 ? lastRow : row - 1;
    }
    productIndex = productIndex === 0 ? lastProductIndex : productIndex - 1;
  } while (
    !deviceMap[row][column][productIndex] ||
    deviceMap[row][column][productIndex].input?.disabled ||
    deviceMap[row][column][productIndex].input == null
  );

  return { row, column, productIndex };
}

export function moveControlEnergyFocusDown(
  sourceRow: number,
  sourceColumn: number,
  sourceProductIndex: number,
  lastRow: number,
  lastColumn: number,
  lastProductIndex: number,
  deviceMap: ProductInput[][][],
) {
  let row = sourceRow;
  let column = sourceColumn;
  let productIndex = sourceProductIndex;

  do {
    if (row === lastRow && productIndex === lastProductIndex) {
      column = column === lastColumn ? 0 : column + 1;
    }
    if (productIndex === lastProductIndex) {
      row = row === lastRow ? 0 : row + 1;
    }
    productIndex = productIndex === lastProductIndex ? 0 : productIndex + 1;
  } while (
    !deviceMap[row][column][productIndex] ||
    deviceMap[row][column][productIndex].input?.disabled ||
    deviceMap[row][column][productIndex].input == null
  );

  return { row, column, productIndex };
}

export function moveControlEnergyFocusLeft(
  sourceRow: number,
  sourceColumn: number,
  sourceProductIndex: number,
  lastRow: number,
  lastColumn: number,
  lastProductIndex: number,
  deviceMap: ProductInput[][][],
) {
  let row = sourceRow;
  let column = sourceColumn;
  let productIndex = sourceProductIndex;

  do {
    if (column === 0 && productIndex === 0) {
      row = row === 0 ? lastRow : row - 1;
    }
    if (column === 0) {
      productIndex = productIndex === 0 ? lastProductIndex : productIndex - 1;
    }
    column = column === 0 ? lastColumn : column - 1;
  } while (
    !deviceMap[row][column][productIndex] ||
    deviceMap[row][column][productIndex].input?.disabled ||
    deviceMap[row][column][productIndex].input == null
  );

  return { row, column, productIndex };
}

export function moveControlEnergyFocusRight(
  sourceRow: number,
  sourceColumn: number,
  sourceProductIndex: number,
  lastRow: number,
  lastColumn: number,
  lastProductIndex: number,
  deviceMap: ProductInput[][][],
) {
  let row = sourceRow;
  let column = sourceColumn;
  let productIndex = sourceProductIndex;

  do {
    if (column === lastColumn && productIndex === lastProductIndex) {
      row = row === lastRow ? 0 : row + 1;
    }
    if (column === lastColumn) {
      productIndex = productIndex === lastProductIndex ? 0 : productIndex + 1;
    }
    column = column === lastColumn ? 0 : column + 1;
  } while (
    !deviceMap[row][column][productIndex] ||
    deviceMap[row][column][productIndex].input?.disabled ||
    deviceMap[row][column][productIndex].input == null
  );

  return { row, column, productIndex };
}
